"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var UiStateController_1 = require("../../../../../shared/UiStateController");
var routes_1 = require("../../../../shared/includes/routes");
var CmsPostCategoryList_1 = require("./component/CmsPostCategoryList");
var CmsPostCategoryEditor_1 = require("./component/CmsPostCategoryEditor");
var CmsPostRecordsList_1 = require("./component/CmsPostRecordsList");
var CmsPostRecordEditor_1 = require("./component/CmsPostRecordEditor");
var CmsPostRecordRawEditor_1 = require("./component/CmsPostRecordRawEditor");
var CmsPostRecordCk4Editor_1 = require("./component/CmsPostRecordCk4Editor");
var PCmsPostsList = /** @class */ (function (_super) {
    __extends(PCmsPostsList, _super);
    function PCmsPostsList(props) {
        return _super.call(this, props) || this;
    }
    PCmsPostsList.prototype.componentWillMount = function () {
        var _this = this;
        this.SID_AB = this.props.listBrandsAvail.Subscribe("*", function (id, data) {
            _this.setState({
                avail_brands: data.data
            });
        });
        this.SID_AL = this.props.listAppLangsAvail.Subscribe("*", function (id, data) {
            _this.setState({
                avail_langs: data.data
            });
        });
        this.SID_STATE = this.props.state.Subscribe("*", function (id, data) {
            _this.setState({
                brands_list: data.brands_list,
                all_brands: data.all_brands,
                page_size: data.tablePageSize
            });
        });
        this.setState({
            edit_mode: "LIST-CATEGORY",
            item_category: null,
            //  item_data: null,
            item_record: null,
            brands_list: this.props.state.getBrandsList(),
            all_brands: this.props.state.getIsAllBrands(),
            avail_brands: [],
            avail_langs: [],
            page_category_num: 1,
            page_size: this.props.state.getTablePageSize(),
            page_data_num: 1,
            page_record_num: 1,
            base64_content: ""
        }, function () {
            _this.props.listBrandsAvail.LoadData();
            _this.props.listAppLangsAvail.LoadData();
        });
    };
    PCmsPostsList.prototype.componentWillUnmount = function () {
        this.props.listBrandsAvail.UnSubscribe(this.SID_AB);
        this.props.listAppLangsAvail.UnSubscribe(this.SID_AL);
        this.props.state.UnSubscribe(this.SID_STATE);
    };
    PCmsPostsList.prototype.onNewCategoryClick = function () {
        this.setState({ edit_mode: "NEW-CATEGORY", item_category: null });
    };
    //  private onNewDataClick() {
    //      this.setState({ edit_mode: "NEW-DATA", item_data: null });
    //  }
    PCmsPostsList.prototype.onNewRecordClick = function () {
        this.setState({ edit_mode: "NEW-RECORD", item_record: null });
    };
    PCmsPostsList.prototype.onEditCategoryClick = function (id) {
        this.setState({ edit_mode: "EDIT-CATEGORY", item_category: id });
    };
    // private onEditDataClick(id: ICmsPostsDataListItem) {
    //     this.setState({ edit_mode: "EDIT-DATA", item_data: id });
    //  }
    PCmsPostsList.prototype.onEditRecordClick = function (id) {
        this.setState({ edit_mode: "EDIT-RECORD", item_record: id });
    };
    PCmsPostsList.prototype.onEditRecordRawClick = function (id) {
        var _this = this;
        this.props.postRecordsList.GetDataContent(id.key, function (base64Content) {
            _this.setState({ edit_mode: "EDIT-RECORD-RAW", item_record: id, base64_content: base64Content });
        });
    };
    PCmsPostsList.prototype.onEditRecordCk4Click = function (id) {
        var _this = this;
        this.props.postRecordsList.GetDataContent(id.key, function (base64Content) {
            _this.setState({ edit_mode: "EDIT-RECORD-CK4", item_record: id, base64_content: base64Content });
        });
    };
    PCmsPostsList.prototype.onCategoryDetailsClick = function (id) {
        this.setState({ edit_mode: "LIST-RECORD", item_category: id, item_record: null });
    };
    //private onDataDetailsClick(id: ICmsPostsDataListItem) {
    //     this.setState({ edit_mode: "LIST-RECORD", item_data: id, item_record: null });
    // } 
    PCmsPostsList.prototype.onGoBackToCategoryListClick = function () {
        this.setState({ edit_mode: "LIST-CATEGORY", item_category: null });
    };
    //private onGoBackToDataListClick() {
    //    this.setState({ edit_mode: "LIST-DATA", item_data: null });
    //}
    PCmsPostsList.prototype.onGoBackToRecordListClick = function () {
        this.setState({ edit_mode: "LIST-RECORD", item_record: null });
    };
    PCmsPostsList.prototype.onPageCategoryConfigChange = function (PageNum, PageSize) {
        var _this = this;
        this.setState({ page_category_num: PageNum }, function () {
            _this.props.state.setTablePageSize(PageSize, true);
        });
    };
    PCmsPostsList.prototype.onPageDataConfigChange = function (PageNum, PageSize) {
        var _this = this;
        this.setState({ page_data_num: PageNum }, function () {
            _this.props.state.setTablePageSize(PageSize, true);
        });
    };
    PCmsPostsList.prototype.onPageRecordConfigChange = function (PageNum, PageSize) {
        var _this = this;
        this.setState({ page_record_num: PageNum }, function () {
            _this.props.state.setTablePageSize(PageSize, true);
        });
    };
    PCmsPostsList.prototype.onBrandFilterChanged = function (allBrands, BrandId, Action) {
        if (Action === "checkbox") {
            this.props.state.setAllBrands(allBrands, true);
        }
        if (Action === "add") {
            this.props.state.addBrand(BrandId, true);
        }
        if (Action === "remove") {
            this.props.state.delBrand(BrandId, true);
        }
    };
    PCmsPostsList.prototype.getRenderObject = function () {
        if (this.state.edit_mode === "NEW-CATEGORY") {
            return (React.createElement(CmsPostCategoryEditor_1.default, { data: this.props.postCategoryList, state: this.props.state, record: null, onGoBack: this.onGoBackToCategoryListClick.bind(this), brandsList: this.state.avail_brands }));
        }
        /* if (this.state.edit_mode === "NEW-DATA") {
             return (
                 <CmsPostDataEditor
                     data={this.props.postDataList}
                     category={this.state.item_category}
                     state={this.props.state}
                     record={null}
                     onGoBack={this.onGoBackToDataListClick.bind(this)}
                 />
             )
         }*/
        if (this.state.edit_mode === "NEW-RECORD") {
            return (React.createElement(CmsPostRecordEditor_1.default, { data: this.props.postRecordsList, rootRecord: this.state.item_category, state: this.props.state, record: null, onGoBack: this.onGoBackToRecordListClick.bind(this), languagesList: this.state.avail_langs, dialogSelectImage: this.props.dialogSelectImage }));
        }
        if (this.state.edit_mode === "EDIT-CATEGORY") {
            return (React.createElement(CmsPostCategoryEditor_1.default, { data: this.props.postCategoryList, state: this.props.state, record: this.state.item_category, onGoBack: this.onGoBackToCategoryListClick.bind(this), brandsList: this.state.avail_brands }));
        }
        /*if (this.state.edit_mode === "EDIT-DATA") {
            return (
                <CmsPostDataEditor
                    data={this.props.postDataList}
                    category={this.state.item_category}
                    state={this.props.state}
                    record={this.state.item_data}
                    onGoBack={this.onGoBackToDataListClick.bind(this)}
                />
            )
        }*/
        if (this.state.edit_mode === "EDIT-RECORD") {
            return (React.createElement(CmsPostRecordEditor_1.default, { data: this.props.postRecordsList, record: this.state.item_record, rootRecord: this.state.item_category, state: this.props.state, onGoBack: this.onGoBackToRecordListClick.bind(this), languagesList: this.state.avail_langs, dialogSelectImage: this.props.dialogSelectImage }));
        }
        if (this.state.edit_mode === "EDIT-RECORD-RAW") {
            return (React.createElement(CmsPostRecordRawEditor_1.default, { data: this.props.postRecordsList, record: this.state.item_record, state: this.props.state, onGoBack: this.onGoBackToRecordListClick.bind(this), textBase64: this.state.base64_content }));
        }
        if (this.state.edit_mode === "EDIT-RECORD-CK4") {
            return (React.createElement(CmsPostRecordCk4Editor_1.default, { data: this.props.postRecordsList, record: this.state.item_record, state: this.props.state, onGoBack: this.onGoBackToRecordListClick.bind(this), textBase64: this.state.base64_content, dialogSelectImage: this.props.dialogSelectImage }));
        }
        if (this.state.edit_mode === "LIST-CATEGORY") {
            return (React.createElement(CmsPostCategoryList_1.default, { data: this.props.postCategoryList, state: this.props.state, onNewClick: this.onNewCategoryClick.bind(this), onEditClick: this.onEditCategoryClick.bind(this), onPageConfigChanged: this.onPageCategoryConfigChange.bind(this), pageNum: this.state.page_category_num, pageSize: this.state.page_size, brandsList: this.state.brands_list, allBrands: this.state.all_brands, availBrands: this.state.avail_brands, onBrandFilterChanged: this.onBrandFilterChanged.bind(this), onDetailsClick: this.onCategoryDetailsClick.bind(this) }));
        }
        /*if (this.state.edit_mode === "LIST-DATA") {
            return (
                <CmsPostDataList
                    data={this.props.postDataList}
                    state={this.props.state}
                    category={this.state.item_category}
                    onNewClick={this.onNewDataClick.bind(this)}
                    onEditClick={this.onEditDataClick.bind(this)}
                    onPageConfigChanged={this.onPageDataConfigChange.bind(this)}
                    pageNum={this.state.page_data_num}
                    pageSize={this.state.page_size}
                    onDetailsClick={this.onDataDetailsClick.bind(this)}
                    onGoBackClick={this.onGoBackToCategoryListClick.bind(this)}
                />
            )
        } */
        if (this.state.edit_mode === "LIST-RECORD") {
            return (React.createElement(CmsPostRecordsList_1.default, { data: this.props.postRecordsList, state: this.props.state, root: this.state.item_category, onNewClick: this.onNewRecordClick.bind(this), onEditClick: this.onEditRecordClick.bind(this), onEditRawClick: this.onEditRecordRawClick.bind(this), onEditVisualClick: this.onEditRecordCk4Click.bind(this), onPageConfigChanged: this.onPageRecordConfigChange.bind(this), pageNum: this.state.page_data_num, pageSize: this.state.page_size, onGoBackClick: this.onGoBackToCategoryListClick.bind(this) }));
        }
        throw "No available render for active edit mode -> " + this.state.edit_mode;
    };
    PCmsPostsList.prototype.render = function () {
        return this.getRenderObject();
    };
    PCmsPostsList.getPageDescription = function (state) {
        return {
            icon: "list-alt",
            iconKind: "normal",
            itemId: "item-" + routes_1.routes.page_cms_posts_list + "-id",
            itemTitle: "Записи",
            route: routes_1.routes.page_cms_posts_list,
            docType: UiStateController_1.UIDocumentType.udtRegularPage
        };
    };
    return PCmsPostsList;
}(React.Component));
exports.default = PCmsPostsList;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/cms_posts/ui/PCmsPostsList.tsx
// module id = 2377
// module chunks = 0